var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutercircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.0052,
    cy: 50.6793,
    r: 47.4095,
    transform: "rotate(-90 51.0052 50.6793)",
    fill: "white",
    stroke: "#F7F9FB",
    strokeWidth: 6.53924
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.496 30.083C44.6773 30.083 40.9063 34.2072 36.4453 35.7078C34.6323 36.3203 33.7237 36.6245 33.3583 37.0553C32.9908 37.484 32.8826 38.1149 32.6682 39.3726C30.3672 52.8394 35.3958 65.2895 47.3866 70.1364C48.6748 70.657 49.32 70.9163 50.5021 70.9163C51.6843 70.9163 52.3315 70.657 53.6198 70.1364C65.6105 65.2895 70.633 52.8394 68.332 39.3726C68.1156 38.1149 68.0094 37.4861 67.6419 37.0553C67.2744 36.6245 66.3679 36.3203 64.5549 35.7078C60.0918 34.2072 56.3148 30.083 50.496 30.083Z",
    stroke: "#605BFF",
    strokeWidth: 2.27907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1584 50.841C52.3123 52.9949 55.1503 55.1836 55.1503 55.1836L59.0396 51.2942C59.0396 51.2942 56.851 48.4563 54.697 46.3023C52.5431 44.1484 49.7051 41.9597 49.7051 41.9597L45.8158 45.8491C45.8158 45.8491 48.0044 48.687 50.1584 50.841ZM50.1584 50.841L43.3535 57.6458M59.6868 50.645L54.501 55.8308M50.3564 41.3125L45.1706 46.4983",
    stroke: "#605BFF",
    strokeWidth: 2.27907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutercircle);
export default __webpack_public_path__ + "static/media/outercircle.76884bfd9ae5f3af02ee2d05e3e3483d.svg";
export { ForwardRef as ReactComponent };